// Настройка для дополенний домов
import autoText from './config';
import PerfectScrollbar from 'perfect-scrollbar';
import { clearspaces, ftrim } from 'mdlib';
import houseInfo from 'lib/locations/houses';

/**
 * extra options {
 * 	requireData - убивает надпись если ни один пункт не выбран
 * }
 */

/**
 * Объект загрузки домов
 * либо подгрузка списка с сервера, либо выбор из списка
 */
class FindHouseRequest {
    constructor(street, string) {
        this.values = undefined; // Еще не загружены

        this.street = street;
        this.string = string;

        this.xhr = null;
        this.timeout = null;
    }

    set street(value) {
        if (value === this._street) {
            return;
        }

        this._street = value;
        this.values = undefined;
    }

    get street() {
        return this._street;
    }

    getFiltredValues() {
        var values = this.values || [];
        var str = this.string || '';
        var result;

        str = clearspaces(ftrim(str));

        if (!str) {
            result = values.filter((data) => !!(data.number || data.name));
        } else {
            result = values.filter((data) => {
                var re;
                var name = data.number || data.name;

                if (!name) {
                    return false;
                }

                re = new RegExp(`^(${str})(?![^<>]*>)(?![^&;]+;)`, 'gi');

                return !!re.test(name);
            });
        }

        return result;
    }

    abort() {
        if (this.xhr) {
            this.xhr.abort();
            this.xhr = null;
        }

        if (this.timeout) {
            window.clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    run() {
        // Уже загружено
        if (this.values) {
            return new Promise((resolve, reject) => {
                if (!this.street) {
                    reject('Улица не выбрана');
                    return;
                }

                this.timeout = window.setTimeout(() => {
                    this.timeout = null;
                    resolve(this.getFiltredValues());
                }, 0);
            });
        }

        return new Promise((resolve, reject) => {
            if (!this.street) {
                reject('Улица не выбрана');
                return;
            }

            const request = houseInfo.prepareRequest({
                street_id: this.street,
                limit: 0,
            });

            request.make().then(
                (result) => {
                    this.xhr = null;
                    this.values = result;
                    resolve(this.getFiltredValues());
                },
                () => {
                    this.xhr = null;
                    reject('Ошибка загрузки данных');
                }
            );
            this.xhr = request.xhr;
        });
    }
}

autoText.config.tempaltes.add(
    new autoText.config.tempaltes.Template('house', {
        loading: () => `<li class="ui-inlst-item">
            Загружаем
        </li>`,
        error: (message) => `<li class="ui-inlst-item">
            ${message}
        </li>`,
        empty: () => `<li class="ui-inlst-item">
            Ничего не найдено
        </li>`,
        ok: (data = {}) => {
            var title = data.number || data.name || 'Номер дома не указан';

            return `<li class="ui-inlst-item">
                    ${title}
                </li>`;
        },
        active: (data = {}) => {
            var title = data.number || data.name || 'Номер дома не указан';

            return `<li class="ui-inlst-item active">
                    ${title}
                </li>`;
        },
    })
);

// Получение внешнего вида результата (текст)
autoText.config.results.add(
    new autoText.config.results.Template('house', (opts = {}) => {
        var title = opts.number || opts.name || 'Номер дома не указан';

        return title;
    })
);

autoText.config.loaders.add(
    new autoText.config.loaders.Loader(
        'house',
        (at, val, opts = {}, resolve, reject) => {
            if (!opts.street && opts.streetRequired) {
                reject('Улица не выбрана');
                return null;
            }

            const request = opts.request;

            request.street = opts.street;
            request.string = val;
            opts.request.run().then(
                (results) => {
                    resolve(results);
                },
                (message) => {
                    reject(message);
                }
            );

            return opts.request;
        },
        (current) => {
            if (current) {
                current.abort();
            }
        }
    )
);

autoText.config.eventsCheck
    .add(
        new autoText.config.eventsCheck.Check('house', 'close', (at) => {
            var requireData = at.options.requireData;

            // Если нет уже выбранных данных попытаемся еще раз для сопоставления с написанным
            if (!at.data()) {
                at.select();

                // Сотрем если все равно ничего не нашли
                if (requireData && !at.data()) {
                    at.val('');
                }
            }
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('house', 'select', (at, data) => {
            var result = data;

            if (!result) {
                const query = clearspaces(ftrim(at.val()));

                if (query) {
                    result = at
                        .listData()
                        .find(
                            (value) =>
                                (value.number || value.name).toLowerCase() ===
                                query.toLowerCase()
                        );
                }
            }

            return result || null;
        })
    )
    .add(
        new autoText.config.eventsCheck.Check('house', 'init', (at) => {
            var list = at.list();
            var options = at.options;

            options.request = new FindHouseRequest();

            const perfectSB = new PerfectScrollbar(list.get(0));
            perfectSB.update(list.get(0));
        })
    )
    .add(
        new autoText.config.eventsCheck.Check(
            'house',
            'afterOpen, loadComplete',
            (at) => {
                var list = at.list();

                window.setTimeout(() => {
                    perfectSB.update(list.get(0));
                }, 100);
            }
        )
    );

export default autoText;
